import React from 'react';

const NodeFileSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <rect x="0.785156" width="40" height="40" rx="4" fill="#0744E1" />
      <path
        d="M16.9779 21.1111H23.6445M16.9779 25.5556H25.8668M22.5334 10H13.6445V30H29.2001V16.6667M22.5334 10H23.6445L29.2001 15.5556V16.6667M22.5334 10V14.4444C22.5334 15.5556 23.6445 16.6667 24.7556 16.6667H29.2001"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NodeFileSVG;
